import { useTranslation } from 'react-i18next';
import { TeContainer, TeContainerSlim, TeText } from '@topcon/tuicl-react';

import { ServiceAgreementTermsEnum } from '../../../api/generated/pm';
import SelectableAgreementTypeCard from '../../../components/ServiceAgreement/SelectableAgreementTypeCard';
import ServiceAgreementAcknowledgements from '../../../components/ServiceAgreement/ServiceAgreementAcknowledgements';
import { AgreementType } from '../../../types/customer-modal.types';

interface SelectAgreementTypeStepProps {
  type: ServiceAgreementTermsEnum;
  setType: (type: ServiceAgreementTermsEnum) => void;
  onAcknowledgedChange: (acknowledged: boolean) => void;
}

function SelectAgreementTypeStep({
  type,
  setType,
  onAcknowledgedChange,
}: SelectAgreementTypeStepProps) {
  const { t } = useTranslation();

  return (
    <TeContainer
      column
      grow
      backgroundColor="background.secondary"
      gap="m"
      overflow="auto"
      justifyContent="center"
      borderRadius="l"
      fill
      data-testid="modal-step-4"
    >
      <TeContainerSlim fill grow column justifyContent="center" gap="xs">
        <TeText weight={700} size={16}>
          {t('dealers.createModal.agreementTypeTitle')}
        </TeText>
        <TeText weight={400} size={12} color="text.secondary">
          {t('dealers.createModal.agreementTypeSubtitle')}
        </TeText>
      </TeContainerSlim>
      <TeContainerSlim fill grow alignItems="center" gap="xs">
        <SelectableAgreementTypeCard
          title={t('serviceAgreement.full_service')}
          agreementType={AgreementType.FullService}
          isActive={type === ServiceAgreementTermsEnum.FULL_SERVICE}
          onClick={() => setType(ServiceAgreementTermsEnum.FULL_SERVICE)}
        />
        <SelectableAgreementTypeCard
          title={t('serviceAgreement.limited_service')}
          agreementType={AgreementType.LimitedService}
          isActive={type === ServiceAgreementTermsEnum.PARTIAL_SERVICE}
          onClick={() => setType(ServiceAgreementTermsEnum.PARTIAL_SERVICE)}
        />
      </TeContainerSlim>
      <ServiceAgreementAcknowledgements
        side="customer"
        tier={type}
        onAcknowledged={onAcknowledgedChange}
        variant="modal"
      />
    </TeContainer>
  );
}

export default SelectAgreementTypeStep;
